import request from '@/utils/request'

export function login(data) {
    return request({
        url: '/admin/login',
        method: 'post',
        data
    })
}

export function userInfo() {
    return request({
        url: '/admin/info',
        method: 'get'
    })
}

export function changePwd(data) {
    return request({
        url: '/admin/changepwd',
        method: 'post',
        data
    })
}

export function fetchList(query) {
    return request({
        url: '/admin/sysuser/list',
        method: 'get',
        params: query
    })
}

export function save(data) {
    return request({
        url: '/admin/sysuser',
        method: 'post',
        data
    })
}

export function del(data) {
    return request({
        url: '/admin/sysuser/del',
        method: 'post',
        data
    })
}

export function batchUpdate(data) {
    return request({
        url: '/admin/sysuser/batchUpdate',
        method: 'post',
        data
    })
}

export function resetPwd(data) {
    return request({
        url: '/admin/sysuser/resetpwd',
        method: 'post',
        data
    })
}
